import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2", "group-3"];
function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const nrabGroupInfo = {
  "group-0": [
    {
      label: "Gross Amt",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gross_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    }
  ],
  "group-1": [
    {
      label: "Total Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    },
    {
      label: "Add(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "add",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    {
      label: "Grand Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
  ],
  "group-2": [
    {
        label: "Consignor GST",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "consignor_gst",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getConsignorSuggestions",
        url: SERVER_URL + "/consignor/",
        suggestionKeyword: "consignor_gst",
        suggestionKeywordForFetchApiArgs: "gst",
        suggestionChooseQueryKeyword: "consignor_id",
        suggestionSchema: {
          consignor_name: "consignor_name",
          consignor_gst: "consignor_gst",
          consignor_id: "consignor_id",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: false,
        regExpValidation:
          "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
        keyboardNavigationMap: {
          Enter: "consignee_name",
        },
        idClearanceNeeded: "consignor_id",
      },
      {
        label: "Extra(%)",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_percentage",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        suggestionBackendResponseMap: {
          id: "station_from",
        },
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "add",
        },
      },
      {
        label: "Hamali Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "hamali_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "RTO Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "rto_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "Detention Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "detention_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
  ],
};
const guruGroupInfo = {
  "group-0": [
    {
      label: "Gross Amt",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gross_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    }
  ],
  "group-1": [
    {
      label: "Total Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    },
    {
      label: "Add(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "add",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    {
      label: "Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gst_amount",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    {
      label: "Net amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "gst_amount",
      },
    },
  ],
  "group-2": [
    {
        label: "Consignor GST",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "consignor_gst",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getConsignorSuggestions",
        url: SERVER_URL + "/consignor/",
        suggestionKeyword: "consignor_gst",
        suggestionKeywordForFetchApiArgs: "gst",
        suggestionChooseQueryKeyword: "consignor_id",
        suggestionSchema: {
          consignor_name: "consignor_name",
          consignor_gst: "consignor_gst",
          consignor_id: "consignor_id",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: false,
        regExpValidation:
          "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
        keyboardNavigationMap: {
          Enter: "consignee_name",
        },
        idClearanceNeeded: "consignor_id",
      },
      {
        label: "Extra(%)",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_percentage",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        suggestionBackendResponseMap: {
          id: "station_from",
        },
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "add",
        },
      },
      {
        label: "Extra Hamali",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_hamali",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "DD Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "door_del_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "Bilty Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "bilty_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
  ],
};
const bgtcGroupInfo = {
  "group-0": [
    {
      label: "Gross Amt",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gross_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    }
  ],
  "group-1": [
    {
      label: "Total Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    },
    {
      label: "Add(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "add",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    {
      label: "Grand Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
  ],
  "group-2": [
    {
        label: "Consignor GST",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "consignor_gst",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getConsignorSuggestions",
        url: SERVER_URL + "/consignor/",
        suggestionKeyword: "consignor_gst",
        suggestionKeywordForFetchApiArgs: "gst",
        suggestionChooseQueryKeyword: "consignor_id",
        suggestionSchema: {
          consignor_name: "consignor_name",
          consignor_gst: "consignor_gst",
          consignor_id: "consignor_id",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: false,
        regExpValidation:
          "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
        keyboardNavigationMap: {
          Enter: "consignee_name",
        },
        idClearanceNeeded: "consignor_id",
      },
      {
        label: "Extra(%)",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_percentage",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        suggestionBackendResponseMap: {
          id: "station_from",
        },
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "add",
        },
      },
      {
        label: "Extra Hamali",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_hamali",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "DD Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "door_del_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "Bilty Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "bilty_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
  ],
};
const defaulGroupInfo = {
  "group-0": [
    {
      label: "Gross Amt",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gross_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    }
  ],
  "group-1": [
    {
      label: "Total Amount",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      suggestionBackendResponseMap: {
        id: "station_from",
      },
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "add",
      },
    },
    {
      label: "Add(+)",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "add",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    {
      label: "Grand Total",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "net_amount",
      type: "text",
      placeHolder: "",
      url: SERVER_URL + "/city/",
      suggestionKeyword: "name",
      backendOnClickName: "station_from",
      toValidate: false,
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
  ],
  "group-2": [
    {
        label: "Consignor GST",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "consignor_gst",
        type: "text",
        placeHolder: "",
        apiConfigKey: "getConsignorSuggestions",
        url: SERVER_URL + "/consignor/",
        suggestionKeyword: "consignor_gst",
        suggestionKeywordForFetchApiArgs: "gst",
        suggestionChooseQueryKeyword: "consignor_id",
        suggestionSchema: {
          consignor_name: "consignor_name",
          consignor_gst: "consignor_gst",
          consignor_id: "consignor_id",
        },
        apiCallRequiredOnGetValue: true,
        toValidate: false,
        regExpValidation:
          "^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$",
        keyboardNavigationMap: {
          Enter: "consignee_name",
        },
        idClearanceNeeded: "consignor_id",
      },
      {
        label: "Extra(%)",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_percentage",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        suggestionBackendResponseMap: {
          id: "station_from",
        },
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "add",
        },
      },
      {
        label: "Extra Hamali",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input-small",
        name: "extra_hamali",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "DD Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "door_del_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
      {
        label: "Bilty Charge",
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",
        name: "bilty_charge",
        type: "text",
        placeHolder: "",
        url: SERVER_URL + "/city/",
        suggestionKeyword: "name",
        backendOnClickName: "station_from",
        toValidate: false,
        keyboardNavigationMap: {
          Enter: "save_button",
        },
      },
  ],
};

const getGroupInfoBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam"){
    return nrabGroupInfo
  }
  if (process.env.REACT_APP_CLIENT == "guru"){
    return guruGroupInfo
  }
  if (process.env.REACT_APP_CLIENT == "bgtc"){
    return bgtcGroupInfo
  }
  else {
    return defaulGroupInfo
  }
}

var groupInfo = getGroupInfoBasedOnClient()

const bbacDataObject = {
  id:"",
  // bill_no:"",
  gst_amount: "",
  cgst: "",
  sgst: "",
  igst: "",
  consignor_name: "",
  consignor_id: "",
  consignor_gst: "",
  hamali_charge:"",
  rto_charge:"",
  detention_charge:"",
  extra_hamali:"",
  extra_percentage:"",
  door_del_charge:"",
  bilty_charge:"",
  gross_amount:"",
  total_amount: "",
  other_amount:"",
  remarks:"",
  bill_no:"",
  description1:"",
  description2:"",
  description3:"",
  amt1:"",
  amt2:"",
  amt3:"",
  id:"",
  add: "",
  net_amount: "",
  bilty_ids: [],
  created_from: "",
  created_by: "",
  input_date: formatDate(new Date()),
  input_date_from: formatDate(new Date()),
  update_date_from: formatDate(new Date()),
  update_date_to: formatDate(new Date()),
  bill_date: formatDate(new Date()),
  consignor_bill_no: "",
  last_consignor_bill_no: "",
  amount: "",
  edit_bill: "",
  send_email: false,
  subject: "",
  email: "",
  cc_email: "",
  cc_emails: "",
  body_start: "",
  body_end: "",
  total_pkgs: "",
  total_weight: "",
  bill_name: "",
};

const defaultDataObject = {
  id:"",
  // bill_no:"",
  gst_amount: "",
  cgst: "",
  sgst: "",
  igst: "",
  consignor_name: "",
  consignor_id: "",
  consignor_gst: "",
  hamali_charge:"",
  rto_charge:"",
  detention_charge:"",
  extra_hamali:"",
  extra_percentage:"",
  door_del_charge:"",
  bilty_charge:"",
  gross_amount:"",
  total_amount: "",
  other_amount:"",
  remarks:"",
  bill_no:"",
  description1:"",
  description2:"",
  description3:"",
  amt1:"",
  amt2:"",
  amt3:"",
  id:"",
  add: "",
  net_amount: "",
  bilty_ids: [],
  created_from: "",
  created_by: "",
  input_date: formatDate(new Date()),
  input_date_from: formatDate(new Date()),
  update_date_from: formatDate(new Date()),
  update_date_to: formatDate(new Date()),
  bill_date: formatDate(new Date()),
  consignor_bill_no: "",
  last_consignor_bill_no: "",
  amount: "",
  edit_bill: "",
  send_email: false,
  subject: "",
  email: "",
  cc_email: "",
  cc_emails: "",
  body_start: "",
  body_end: "",
  total_pkgs: "",
  total_weight: "",
};

const getDataObjectBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "bbac"){
    return bbacDataObject
  }
  else {
    return defaultDataObject
  }
}

var dataObject = getDataObjectBasedOnClient()

const nrabConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Truck No.", className: "text-center table-header" },
  { label: "Billing Party", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
  { label: "Hamali charge", className: "text-center table-header" },
  { label: "DD Charge", className: "text-center table-header" },
];

const gdalaConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Billing Party", className: "text-center table-header" },
  { label: "Station", className: "text-center table-header" },
  { label: "Type", className: "text-center table-header" },
  { label: "Invoice", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "D.D.", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
];

const chamundaConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Truck No.", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "PR No.", className: "text-center table-header" },
  { label: "LOT No.", className: "text-center table-header" },
  { label: "PO No.", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Detention", className: "text-center table-header" },
  { label: "RTO", className: "text-center table-header" },
  { label: "Advance", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
];

const avrConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Billing Party", className: "text-center table-header" },
  { label: "Station", className: "text-center table-header" },
  { label: "Invoice", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "D.D.", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
];

const bgtcignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Ref No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  // { label: "Billing Party", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  // { label: "Invoice", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  // { label: "D.D.", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Item Amount", className: "text-center table-header" },
  { label: "Remarks", className: "text-center table-header" },
];

const nptcConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Billing Party", className: "text-center table-header" },
  { label: "Station", className: "text-center table-header" },
  { label: "Invoice", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "D.D.", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
];

const sraConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "MR No.", className: "text-center table-header" },
  { label: "MR Date", className: "text-center table-header" },
  { label: "LR No", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Freight", className: "text-center table-header" },
  { label: "Handling Charge", className: "text-center table-header" },
  { label: "Unloading Charge", className: "text-center table-header" },
  { label: "D.D.", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
];

const defaultConsignorBillingTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Billing Party", className: "text-center table-header" },
  { label: "Station", className: "text-center table-header" },
  { label: "Invoice", className: "text-center table-header" },
  { label: "Delivery Type", className: "text-center table-header" },
  { label: "Description", className: "text-center table-header" },
  { label: "D.D.", className: "text-center table-header" },
  { label: "Pkgs", className: "text-center table-header" },
  { label: "Weight in Kgs", className: "text-center table-header" },
  { label: "Rate C/B/Kg", className: "text-center table-header" },
  { label: "Amount Rs.", className: "text-center table-header" },
  // { label: "Actual Weight", className: "text-center table-header" },
  // { label: "Charge Weight", className: "text-center table-header" },
  // { label: "Private Marka No", className: "text-center table-header" },
  // { label: "Goods Invoice Value", className: "text-center table-header" },
  // { label: "Delivery Dest Type", className: "text-center table-header" },
  // { label: "Remarks", className: "text-center table-header" },
  // { label: "Bilty Charge", className: "text-center table-header" },
  // { label: "Other Amount", className: "text-center table-header" },
  // { label: "Freight", className: "text-center table-header" },
  // { label: "Hamali", className: "text-center table-header" },
  // { label: "Door Del Charge", className: "text-center table-header" },
];

const nrabConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "vehicle_no",
    label: "Truck No.",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "freight",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "hamali_charge",
    label: "Hamali charge",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "DD Charge",
    className: "form-control-medium-col",
  },
];
const gdalaConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "type",
    label: "Pay Type",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "D.D.",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "freight",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
];

const chamundaConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "vehicle_no",
    label: "Truck No.",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "pr_no",
    label: "PR No.",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "lot_no",
    label: "LOT No.",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "po_no",
    label: "PO No.",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_detention",
    label: "Detention",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_rto",
    label: "RTO",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_advance",
    label: "Advance",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
];

const avrConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "D.D.",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
];

const bgtcConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "reference_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "private_marka_no",
  //   label: "Invoice",
  //   className: "form-control-medlarge-col",
  // },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  // {
  //   type: "text",
  //   name: "door_del_charge",
  //   label: "D.D.",
  //   className: "form-control-small-col",
  // },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "item_amount",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bill_remarks",
    label: "Remarks",
    className: "form-control-medlarge-col",
  },
];

const nptcConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "D.D.",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
];

const sraConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "lr_no",
    label: "LR No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "freight",
    label: "Freight",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_charge",
    label: "Holding Charge",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "hamali",
    label: "Unloading Charge",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "Unloading Charge",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Total Amount",
    className: "form-control-medlarge-col",
  },
];

const defaultConsignorBillingTableItems = [
  {
    type: "text",
    name: "bilty_no_suffix",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  //   convertFunction: (itemObject)=>{
  //     return formatDate(itemObject.created_date)
  //   }
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor name",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "private_marka_no",
    label: "Invoice",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "delivery_dest_type",
    label: "Delivery Type",
    className: "form-control-medlargemed-col",
  },
  {
    type: "text",
    name: "item_name",
    label: "Description",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "door_del_charge",
    label: "D.D.",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "weight",
    label: "Weight in Kgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "rate",
    label: "Rate C/B/Kg",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "freight",
    label: "Amount Rs.",
    className: "form-control-medium-col",
  },
];

const getConsignorBillingTableHeaderBasedOnClient = () => {
  const headerMap = {
    nrab: nrabConsignorBillingTableHeader,
    syt: nrabConsignorBillingTableHeader,
    sangam: nrabConsignorBillingTableHeader,
    gdala_log: gdalaConsignorBillingTableHeader,
    xpress: chamundaConsignorBillingTableHeader,
    avr: avrConsignorBillingTableHeader,
    sgtc: avrConsignorBillingTableHeader,
    jtsa: avrConsignorBillingTableHeader,
    bbac: avrConsignorBillingTableHeader,
    std: avrConsignorBillingTableHeader,
    arbuda: avrConsignorBillingTableHeader,
    bgtc: bgtcignorBillingTableHeader,
    nptc: nptcConsignorBillingTableHeader,
    sra: sraConsignorBillingTableHeader,
  };

  return headerMap[process.env.REACT_APP_CLIENT] || defaultConsignorBillingTableHeader;
};
const getConsignorBillingTableItemsBasedOnClient = () => {
  const itemsMap = {
    nrab: nrabConsignorBillingTableItems,
    syt: nrabConsignorBillingTableItems,
    sangam: nrabConsignorBillingTableItems,
    gdala_log: gdalaConsignorBillingTableItems,
    xpress: chamundaConsignorBillingTableItems,
    avr: avrConsignorBillingTableItems,
    sgtc: avrConsignorBillingTableItems,
    jtsa: avrConsignorBillingTableItems,
    bbac: avrConsignorBillingTableItems,
    std: avrConsignorBillingTableItems,
    arbuda: avrConsignorBillingTableItems,
    bgtc: bgtcConsignorBillingTableItems,
    nptc: nptcConsignorBillingTableItems,
    sra: sraConsignorBillingTableItems,
  };

  return itemsMap[process.env.REACT_APP_CLIENT] || defaultConsignorBillingTableItems;
};

var consignorBillingTableHeader = getConsignorBillingTableHeaderBasedOnClient()
var consignorBillingTableItems = getConsignorBillingTableItemsBasedOnClient()

function validate(values) {
  let errors = {};

//   function validator(value, regexp) {
//     var regex = new RegExp(regexp);
//     if (values.hasOwnProperty(value)) {
//       if (!values[value].trim()) {
//         errors[value] = "Required Field";
//       } else if (!regex.test(values[value])) {
//         errors[value] = "Validation Error";
//       } else {
//         errors[value] = "";
//       }
//     }
//   }
//   for (let group_name of groupNames) {
//     for (let i = 0; i < groupInfo[group_name].length; i++) {
//       let field_object = groupInfo[group_name][i];
//       if (field_object.toValidate) {
//         validator(field_object.name, field_object.regExpValidation);
//       }
//     }
//   }
  return errors;
}

const popupInfo = {
  success_header: "Consignor Bill Saving Successful ",
  error_header: "Error In Consignor Bill Module ",
  success_title: "Consignor Bill is successfully created with the following info:-",
  field_label_success: "Consignor Bill",
  field_name_success: "id",
  error_title: "Error in Consignor Bill module with the following info:-",
  field_label_error: "Error:",
};

export { groupInfo, groupNames, dataObject, validate, popupInfo, consignorBillingTableItems,consignorBillingTableHeader };
